import { OnboardingDevice } from '../models/Onboarding/OnboardingDevice'
import { HostOnboardingSteps } from './constants'

export function getCurrentStepFromDevice(
  device: OnboardingDevice | null,
): HostOnboardingSteps {
  if (!device) {
    return HostOnboardingSteps.DevicePhotos
  }

  if (!device.imageUrl || device.imageUrl.length === 0) {
    return HostOnboardingSteps.DevicePhotos
  }

  if (!device.name) {
    return HostOnboardingSteps.DeviceName
  }

  if (!device.screenSize) {
    return HostOnboardingSteps.DeviceSize
  }

  if (!device.monthlyPrice) {
    return HostOnboardingSteps.SetPricing
  }

  if (!device.approvalType) {
    return HostOnboardingSteps.ApprovalType
  }

  return HostOnboardingSteps.Review
}
